// extracted by mini-css-extract-plugin
module.exports = {"aplus_card_wrapper":"aplusCardContent_aplus_card_wrapper__NkEmP"};